import api from '@/api/students';
import store from '@/store';

const getStudentProfile = (context, { classId, studentId }) => new Promise(((resolve, reject) => {
  api.getStudentProfile(classId, studentId)
    .then((response) => {
      context.commit('SAVE_CURRENT_STUDENT', response.student);
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getStudentSkillStats = (context, studentId) => new Promise(((resolve, reject) => {
  api.getStudentSkillStats(studentId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getStudentLatestAssignments = (context, { classId, studentId, counter }) => new Promise(((resolve, reject) => {
  api.getStudentLatestAssignments(classId, studentId, counter)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getStudentSuggestedTasks = (context, { studentId, counter }) => new Promise(((resolve, reject) => {
  api.getStudentSuggestedTasks(studentId, counter)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

// eslint-disable-next-line max-len
const getStudentOpenAssignments = (context, { classId, studentId, page, limit, order, direction }) => new Promise(((resolve, reject) => {
  api.getStudentOpenAssignments(classId, studentId, page, limit, order, direction)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

// eslint-disable-next-line max-len
const getStudentClosedAssignments = (context, { classId, studentId, page, limit, order, direction }) => new Promise(((resolve, reject) => {
  api.getStudentClosedAssignments(classId, studentId, page, limit, order, direction)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

// eslint-disable-next-line
const getStudentActivity = (context, { studentId, page, limit, order, direction }) => new Promise(((resolve, reject) => {
  api.getStudentActivity(studentId, page, limit, order, direction)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getStudentPracticeWeaknesses = (context, studentId) => new Promise(((resolve, reject) => {
  api.getStudentPracticeWeaknesses(studentId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getVocabularyList = (context, { studentId, type, page }) => new Promise((resolve, reject) => {
  api.getVocabularyList(studentId, type, page)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
});

const getSuggestedWeakWords = (context, { studentId, language }) => new Promise((resolve, reject) => {
  api.getSuggestedWeakWords(studentId, language)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
});

const getStudentReport = (context, { classId, studentId, interval }) => new Promise((resolve, reject) => {
  api.getStudentReport(classId, studentId, interval)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
});

const getStudentReportOverview = (context, { classId, studentId }) => new Promise((resolve, reject) => {
  api.getStudentReportOverview(classId, studentId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
});

const downloadStudentReportForPdf = (context, { classId, studentId, interval }) => new Promise((resolve, reject) => {
  api.downloadStudentReportForPdf(classId, studentId, interval)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
});

const grammarSuccessRatesForStudents = (context, students) => new Promise((resolve, reject) => {
  api.grammarSuccessRatesForStudents(students)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
});

const setCurrentStudentName = (context, name) => {
  context.commit('SAVE_CURRENT_STUDENT_NAME', name);
};

const updateStudentStats = (context, studentIds) => new Promise((resolve, reject) => {
  api.updateStudentStats(studentIds)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
});


export default {
  getStudentProfile,
  getStudentSkillStats,
  getStudentLatestAssignments,
  getStudentSuggestedTasks,
  getStudentOpenAssignments,
  getStudentClosedAssignments,
  getStudentActivity,
  getStudentPracticeWeaknesses,
  getVocabularyList,
  getSuggestedWeakWords,
  getStudentReport,
  getStudentReportOverview,
  downloadStudentReportForPdf,
  setCurrentStudentName,
  grammarSuccessRatesForStudents,
  updateStudentStats
};



// WEBPACK FOOTER //
// ./src/store/modules/students/actions.js